import React, { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SalesCreditNoteRegisterForm from '../components/SalesCreditNoteRegisterForm';
import { useGetSalesCreditNoteRegisterHandler } from '../dataHandlers/getSalesCreditNoteRegisterHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function SalesCreditNoteRegisterDetailsPage() {
  const { salesInvoiceRegister } = useTranslatedMessages();
  useDocumentTitle(salesInvoiceRegister?.pages?.details_title_credit_note ?? 'Sales Credit Note Register Details');
  const navigate = useNavigate();
  const { document_id } = useParams();
  const { register, isLoading } = useGetSalesCreditNoteRegisterHandler(document_id);

  useEffect(() => {
    if (!isLoading && register?.document_mode === 'E_INVOICE') {
      const documentId = register.uuid || register.id;
      navigate(`/sales/documents/credit-notes/${documentId}`, { replace: true });
    }
  }, [isLoading, register, navigate]);

  if (isLoading || !register) {
    return <DocumentSkeletonForm />;
  }

  if (register.document_mode === 'E_INVOICE') {
    return <DocumentSkeletonForm />;
  }

  const onClickingBackButton = () => navigate('/sales-invoice-register?tab=credit-notes');

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <SalesCreditNoteRegisterForm
        onSubmit={() => {}}
        onCancel={onClickingBackButton}
        initialData={register}
        readOnly
      />
    </Stack>
  );
}
